import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04ff4e07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "splash" }
const _hoisted_2 = { ref: "grid" }
const _hoisted_3 = { style: { margin: '25px', textAlign: 'center' } }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Are you sure you want to delete the item '")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("'?")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("No")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Yes")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_notification = _resolveComponent("k-notification")!
  const _component_k_button = _resolveComponent("k-button")!
  const _component_k_dialog_actions_bar = _resolveComponent("k-dialog-actions-bar")!
  const _component_k_dialog = _resolveComponent("k-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_k_notification, { ref: "PopupNotification" }, null, 512),
    _createElementVNode("div", _hoisted_2, null, 512),
    (_ctx.visibleDialog)
      ? (_openBlock(), _createBlock(_component_k_dialog, {
          key: 0,
          title: 'Please confirm',
          onClose: _ctx.toggleDialog
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("b", null, _toDisplayString(_ctx.itemToBeDeleted.Name), 1),
              _hoisted_5
            ]),
            _createVNode(_component_k_dialog_actions_bar, null, {
              default: _withCtx(() => [
                _createVNode(_component_k_button, {
                  class: "btn btn-primary",
                  onClick: _ctx.toggleDialog
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_k_button, {
                  class: "btn btn-secondary",
                  onClick: _ctx.deleteItem
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}